import React, { FC, MouseEvent } from 'react'
import { useHistory } from 'react-router'
import omit from 'lodash/omit'
import queryString from 'query-string'
import { Box } from 'transfix-ui/core'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { useBookableShipmentSavedSearchContext } from 'apps/fleet-planner/context/BookableShipmentSavedSearchContext'
import { useLaneFiltersContext } from 'apps/fleet-planner/context/LaneFiltersContext'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'
import { BookableShipmentSavedSearchAlertRowItems } from './BookableShipmentSavedSearchAlertRowItems'

export interface BookableShipmentSavedSearchAlertRowProps {
  savedSearch?: BookableShipmentSavedSearch
  /**
   * Optionally trigger an additional callback on click
   */
  onClick?: () => void
}

export const BookableShipmentSavedSearchAlertRow: FC<BookableShipmentSavedSearchAlertRowProps> = ({
  onClick,
  savedSearch,
}) => {
  const history = useHistory()
  const { trackEvent } = useFMSAnalytics()
  const { changeParams, setHasStartedSearch } = useLaneFiltersContext()
  const { deleteSearch } = useBookableShipmentSavedSearchContext()
  const { getFlag } = useFeatureFlagContext()
  const { enabled: fmsLaneRecommendations } = getFlag('fmsLaneRecommendations')

  const applyFiltersHandlerOld = () => {
    setHasStartedSearch(true)
    changeParams({ filters: savedSearch })
    trackEvent('Lane Alerts', 'CLICKED_LANE_ALERT')
  }

  const openBookLoadsSavedSearchHandler = () => {
    const filters = {
      ...omit(savedSearch, [
        'createdAt',
        'sourceType',
        'totalResultCount',
        'unviewedResultCount',
        'hasNotificationsEnabled',
        'motorCarrier',
        'motorCarrierId',
        'rate',
        'rateType',
        'updatedAt',
      ]),
    }
    const query = queryString.stringify({
      ...filters,
    })
    history.push(`/book/?${query}`)
  }

  const rowClickHandler = () => {
    if (onClick) {
      onClick()
    }

    if (fmsLaneRecommendations) {
      openBookLoadsSavedSearchHandler()
    } else {
      applyFiltersHandlerOld()
    }
  }

  const deleteClickHandler = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    deleteSearch(savedSearch?.id)
    trackEvent('Lane Alerts', 'DELETED_LANE_ALERT')
  }

  return (
    <Box onClick={rowClickHandler} p={0.75}>
      <BookableShipmentSavedSearchAlertRowItems
        savedSearch={savedSearch}
        onDelete={deleteClickHandler}
      />
    </Box>
  )
}
